import { buildProps, definePropType } from '@ll-plus/utils'
import { SizeType } from 'ant-design-vue/es/config-provider'
import { ExtractPropTypes } from 'vue'
import type Slider from './slider.vue'

// props
export const sliderProps = buildProps({
  value: {
    type: definePropType<number[] | number>([Array, Number]),
    default: 0,
  },
  // 是否显示数字输入框
  showInput: {
    type: Boolean,
    default: false,
  },
  // 最小值
  min: {
    type: Number,
    default: 0,
  },
  // 最大值
  max: {
    type: Number,
    default: 100,
  },
  // 是否垂直
  vertical: {
    type: Boolean,
    default: false,
  },
  // 反向坐标轴
  reverse: {
    type: Boolean,
    default: false,
  },
  // 禁用
  disabled: {
    type: Boolean,
    default: false,
  },
  // 步长
  step: {
    type: Number,
    default: 1,
  },
  // 垂直高度
  verticalHeight: {
    type: String,
    default: '200px',
  },
  // 输入框大小
  inputSize: {
    type: String as () => SizeType,
  },
  // 输入框宽度
  inputWidth: {
    type: String,
    default: '100px',
  },
  // 线条粗细
  lineWeight: {
    type: String as () => SizeType,
    default: 'small',
  },
} as const)

export const sliderEmits = {
  'update:value': (value: number | number[]) =>
    !!value || typeof value === 'number',
  change: (value: number | number[]) => !!value || typeof value === 'number',
} as const

// emits
export type SliderEmits = typeof sliderEmits

// props
export type SliderProps = ExtractPropTypes<typeof sliderProps>

// instance
export type SliderInstance = InstanceType<typeof Slider>
